import { ruDateTime } from '../../lib/format';

/** Момент ISO по местному времени объекта: `YYYY-MM-DD` (дата публикации версии, закрепления примера, просьбы). */
export function localDate(iso: string, tzOffset: string): string {
  if (Number.isNaN(Date.parse(iso))) return iso.slice(0, 10);
  const s = ruDateTime(iso, tzOffset);
  return `${s.slice(6, 10)}-${s.slice(3, 5)}-${s.slice(0, 2)}`;
}
